import { render, staticRenderFns } from "./copyableResultDialog.vue?vue&type=template&id=70b0bcd5&scoped=true&lang=pug"
import script from "./copyableResultDialog.vue?vue&type=script&lang=js"
export * from "./copyableResultDialog.vue?vue&type=script&lang=js"
import style0 from "./copyableResultDialog.vue?vue&type=style&index=0&id=70b0bcd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0bcd5",
  null
  
)

export default component.exports